// extracted by mini-css-extract-plugin
module.exports = {"loading":"Preloader_loading__29Xwg","overlay":"Preloader_overlay__3Wn2w","preloader":"Preloader_preloader__3ATSx"};